import { Component, OnInit, Input } from '@angular/core';
import { onMoment } from '@app/shared/helpers/moment';

@Component({
  selector: 'app-mid-header',
  templateUrl: './mid-header.component.html',
  styleUrls: ['./mid-header.component.scss']
})
export class MidHeaderComponent implements OnInit {
  @Input() inventory;

  constructor() { }

  ngOnInit(): void {
  }

  onMomentEvent(time){
    return onMoment(time);
  }

}
